import {
    AIR_CATEGORIES,
    AIR_CONFIG, APP_LANG,
    CATEGORY_SELECT,
    CHANGE_SEARCH,
    EXCLUSIVE_CHANGE,
    FORM_BRANDS_NAME,
    FORM_EMAIL,
    FORM_POLICY,
    FORM_SUBMIT,
    FORM_SUBSCRIBE,
    HIDE_ERROR,
    HIDE_LOADER,
    HOT_DEAL_CHANGE,
    MAIN_REQUEST,
    MOBILE_FILTER,
    MOBILE_GUIDES,
    MOBILE_MENU,
    MOBILE_TRACKING_CHANGE,
    PAGES_REQUEST,
    RESET_FILTERS,
    SEARCH_ITEMS,
    SET_APP_DATA,
    SHOW_ERROR,
    SHOW_LOADER,
    SUBSCRIBE_SET,
    TOGGLE_INFO
} from "./types";

const REQ_LANG = document.documentElement.lang;

function get_user_marker_please() {
    let user_marker = parseInt(localStorage.getItem('user_marker'));
    if (isNaN(user_marker) || user_marker === undefined) {
        user_marker = null;
    }
    return user_marker;
}

function mamkaGetCookie(name, def) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : def;
}

function mamkaSetCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=travelpayouts.com";
}

export function showLoader() {
    return {type: SHOW_LOADER}
}

export function hideLoader() {
    return {type: HIDE_LOADER}
}

export function showError() {

    return {type: SHOW_ERROR}
}

export function hideError() {
    return {type: HIDE_ERROR}
}

export function mainRequest() {
    return {type: MAIN_REQUEST}
}

export function category_click(category) {
    let user_marker = get_user_marker_please();

    let attr_parameters = {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        promotion_code_id: null,
        referral_marker: null,
        ad_source: null,
        ad_content: null,
        tp_referrer: null,
    }
    attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
    attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
    attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
    attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
    attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
    attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
    attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
    attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
    attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
    attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);
    window.mamka('trackStructEvent', 'brand_store', 'click_on_category', null, null, null, {
        marker: user_marker,
        attr_parameters: attr_parameters,
        category: category
    });
}

export function detail_click(brand, brand_id, brand_link, botton_position) {
    let user_marker = get_user_marker_please();
    let attr_parameters = {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        promotion_code_id: null,
        referral_marker: null,
        ad_source: null,
        ad_content: null,
        tp_referrer: null,
    }
    attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
    attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
    attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
    attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
    attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
    attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
    attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
    attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
    attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
    attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);
    window.mamka('trackStructEvent', 'brand_store', 'click_on_brand', null, null, null, {
        marker: user_marker,
        attr_parameters: attr_parameters,
        brand: brand,
        brand_id: brand_id,
        brand_link: brand_link,
        position: botton_position
    });
    if (botton_position === 'button') {


        window.dataLayer.push({
            'event': 'GAEvent',
            'eventId': 'd-v4-2',
            'eventCategory': 'Brands Directory',
            'eventAction': 'click',
            'eventLabel': 'brandsDirectory_click_detailsButton | ' + brand,
            'nonInteraction': false
        });

        window.dataLayer.push({
            'event': 'GA4Event',
            'eventId': 'd-v4-2',
            'eventName': 'brandsDirectory_click_detailsButton',
            'brand': brand
        });
    }
    if (botton_position === 'logo') {


        window.dataLayer.push({
            'event': 'GAEvent',
            'eventId': 'd-v4-3',
            'eventCategory': 'Brands Directory',
            'eventAction': 'click',
            'eventLabel': 'brandsDirectory_click_detailsCard | ' + brand,
            'nonInteraction': false
        });

        window.dataLayer.push({
            'event': 'GA4Event',
            'eventId': 'd-v4-3',
            'eventName': 'brandsDirectory_click_detailsCard',
            'brand': brand
        });

    }

}

export function signin_click() {
    let user_marker = get_user_marker_please();
    let attr_parameters = {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        promotion_code_id: null,
        referral_marker: null,
        ad_source: null,
        ad_content: null,
        tp_referrer: null,
    }
    attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
    attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
    attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
    attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
    attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
    attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
    attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
    attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
    attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
    attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);
    window.mamka('trackStructEvent', 'brand_store', 'sign_in', null, null, null, {
        marker: user_marker,
        attr_parameters: attr_parameters,
    });
}

export function signup_click(botton_position, brand, brand_id) {
    let user_marker = get_user_marker_please();
    let attr_parameters = {
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null,
        promotion_code_id: null,
        referral_marker: null,
        ad_source: null,
        ad_content: null,
        tp_referrer: null,
    }
    attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
    attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
    attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
    attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
    attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
    attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
    attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
    attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
    attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
    attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);
    window.mamka('trackStructEvent', 'brand_store', 'register', null, null, null, {
        marker: user_marker,
        attr_parameters: attr_parameters,
        position: botton_position,
        brand: brand,
        brand_id: brand_id,
    });
    window.dataLayer.push({
        'event': 'GAEvent',
        'eventId': 'd-v4-1',
        'eventCategory': 'User',
        'eventAction': 'click',
        'eventLabel': 'brandsDirectory_click_joinNow | ' + brand,
        'nonInteraction': false
    });

    window.dataLayer.push({
        'event': 'GA4Event',
        'eventId': 'd-v4-1',
        'eventName': 'brandsDirectory_click_joinNow',
        'brand': brand
    });

}

export function getPagesRequest(category) {
    return async dispatch => {
        await fetch('https://www.travelpayouts.com/brands-directory/api/api.php?key=11eb6dd2f9dcf57686b;sd6f609d853f9c&type=pages&locale='+APP_LANG, {
            method: 'GET',
        }).then(res => res.json()).then((result) => {
            let app_lang = APP_LANG;
            let current_page = null;
            let current_category = '';
            if (result.records) {
                if (category.length > 0) {
                    result.records.forEach((item) => {
                        if (item.fields.locale && item.fields.locale && item.fields.locale === app_lang) {
                            if (item.fields.slug && item.fields.slug.length > 0 && item.fields.slug === category) {
                                current_page = item.fields;
                                if (item.fields.select_category_slug !== undefined && item.fields.select_category_slug.length > 0) {
                                    current_category = item.fields.select_category_slug;
                                }
                            }
                        }
                    });
                }
                const payload = {
                    pages: result.records,
                    current_page: current_page,
                    current_category: current_category
                };
                dispatch({type: PAGES_REQUEST, payload: payload});
            }
        }, (error) => {
            dispatch(showError());
        });
    }
}

export function getCategoriesRequest(category, current_page) {
    return async dispatch => {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('marker')) {
            let marker = searchParams.get('marker')
            mamkaSetCookie('marker', marker, 30);
        }
        await fetch('https://www.travelpayouts.com/brands-directory/api/api.php?key=11eb6dd2f9dcf57686b;sd6f609d853f9c&type=categories&locale='+APP_LANG, {
            method: 'GET',
        }).then(res => res.json()).then((result) => {
            let user_marker = parseInt(result.partners_marker);
            if (isNaN(user_marker) || user_marker === undefined || user_marker === 0) {
                user_marker = null;
            }
            localStorage.setItem('user_marker', user_marker);
            let attr_parameters = {
                utm_source: null,
                utm_medium: null,
                utm_campaign: null,
                utm_term: null,
                utm_content: null,
                promotion_code_id: null,
                referral_marker: null,
                ad_source: null,
                ad_content: null,
                tp_referrer: null,
            }
            attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
            attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
            attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
            attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
            attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
            attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
            attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
            attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
            attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
            attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);

            if (window.mamka) {
                try {
                    window.mamka('send_page_view', {
                        marker: user_marker,
                        attr_parameters: attr_parameters,
                    });
                } catch (e) {
                    console.log(e)
                }
            }
            if (result.records) {
                let current_category = '';
                let app_lang = APP_LANG;
                if (category.length > 0 && current_page === null) {
                    result.records.forEach((item) => {
                        if (item.fields.locale && item.fields.locale && item.fields.locale === app_lang) {
                            if (item.fields.slug && item.fields.slug.length > 0 && item.fields.slug === category) {
                                current_category = item.fields.slug;
                            }
                        }
                    });
                    if (current_category === '') {
                        dispatch(showError())
                    }
                }
                if (current_page !== null) {
                    if (current_page.select_category_slug !== undefined) {
                        current_category = current_page.select_category_slug
                    }
                }

                const payload = {
                    aircategories: result.records,
                    current_category: current_category,
                };
                dispatch({type: AIR_CATEGORIES, payload: payload})
            }
        }, (error) => {
            dispatch(showError());
        });
    }
}

export function getConfigRequest() {
    return async dispatch => {
        await fetch('https://www.travelpayouts.com/brands-directory/api/api.php?key=11eb6dd2f9dcf57686b;sd6f609d853f9c&type=config&locale='+APP_LANG, {
            method: 'GET',
        }).then(res => res.json()).then((result) => {
            if (result.records) {
                const payload = {
                    airconfig: result.records,
                };
                dispatch({type: AIR_CONFIG, payload: payload})
            }
        }, (error) => {
            dispatch(showError());
        });
    }
}

export function getSearchRequest() {
    return async dispatch => {
        await fetch('https://www.travelpayouts.com/brands-directory/api/api.php?key=11eb6dd2f9dcf57686b;sd6f609d853f9c&type=search&locale='+APP_LANG, {
            method: 'GET',
        }).then(res => res.json()).then((result) => {
            if (result.records) {

                const payload = {
                    searchItems: result.records,
                };
                dispatch({type: SEARCH_ITEMS, payload: payload})
            }
        }, (error) => {
            dispatch(showError());
        });
    }
}

export function getAuthRequest() {
    return async dispatch => {
        try {
            await fetch('https://app.travelpayouts.com/api/tp_landings_auth', {
                crossDomain: true,
                method: 'GET',
                credentials: 'include',
                dataType: 'json',
            }).then((res) => res.json()).then((result) => {
                if (result.campaigns && result.campaigns.length > 0) {
                    const payload = {
                        subscribe_type: 2,
                        subscribed_brands: result.campaigns
                    }
                    dispatch({type: SUBSCRIBE_SET, payload: payload})
                } else {
                    const payload = {
                        subscribe_type: 1,
                        subscribed_brands: []
                    }
                    dispatch({type: SUBSCRIBE_SET, payload: payload})
                }
            }, (error) => {
                const payload = {
                    subscribe_type: 1,
                    subscribed_brands: []
                }
                dispatch({type: SUBSCRIBE_SET, payload: payload})
            });
        } catch (e) {
            const payload = {
                subscribe_type: 1,
                subscribed_brands: []
            }
            dispatch({type: SUBSCRIBE_SET, payload: payload})
        }

    }
}


export function getAppData(category) {
    return async dispatch => {
        try {
            await fetch('https://www.travelpayouts.com/brands-directory/api/api.php?key=11eb6dd2f9dcf57686b;sd6f609d853f9c&type=graph&locale='+APP_LANG, {
                method: 'GET',
            }).then(res => res.json()).then((result) => {

                if (result.data.publicBrands && result.data.publicBrands.length > 0) {
                    let categories = [];
                    result.data.publicBrands.map((item) => {
                        item.categories.length > 0 && item.categories.map((cat, index) => {
                            categories[cat.id] = cat.name;
                            return null;
                        })
                        return null;
                    });

                    const payload = {
                        brands: result.data.publicBrands,
                        categories: categories,
                    };
                    dispatch({type: SET_APP_DATA, payload: payload})
                } else {
                    const payload = {
                        brands: [],
                        categories: [],
                    };
                    dispatch({type: SET_APP_DATA, payload: payload})
                    dispatch(showError());
                }
            }, (error) => {
                const payload = {
                    brands: [],
                    categories: [],
                };
                dispatch({type: SET_APP_DATA, payload: payload})
                dispatch(showError());
            });
        } catch (e) {

        }
    }

}

export function searchKeyPress(value) {

    return async dispatch => {
        dispatch({type: CHANGE_SEARCH, payload: value})
    }
}


export function filterCategorySelect(slug) {
    let prefix = '';
    if (APP_LANG === 'ru'){
        prefix = '/ru';
    }
    if (slug === '') {
        window.history.pushState({}, null, prefix+'/brands-directory/');
    } else {
        window.history.pushState({}, null, prefix+'/brands-directory/' + slug);
    }
    return async dispatch => {
        dispatch({type: CATEGORY_SELECT, payload: slug})
    }
}

export function mobileTrackingChange(checked) {
    return async dispatch => {
        dispatch({type: MOBILE_TRACKING_CHANGE, payload: !checked})
    }
}

export function exclusiveChange(checked) {
    return async dispatch => {
        dispatch({type: EXCLUSIVE_CHANGE, payload: !checked})
    }
}

export function hotDealChange(checked) {
    return async dispatch => {
        dispatch({type: HOT_DEAL_CHANGE, payload: !checked})
    }
}

export function resetFilter() {
    let prefix = '';
    if (APP_LANG === 'ru'){
        prefix = '/ru';
    }
    window.history.pushState({}, null, prefix+'/brands-directory/');
    return async dispatch => {
        dispatch({type: RESET_FILTERS, payload: null})
    }
}

export function mobile_guides(checked) {
    return async dispatch => {
        dispatch({type: MOBILE_GUIDES, payload: !checked})
    }
}

export function mobile_menu(checked) {
    return async dispatch => {
        dispatch({type: MOBILE_MENU, payload: !checked})
    }
}

export function mobile_filter(checked) {
    return async dispatch => {
        dispatch({type: MOBILE_FILTER, payload: !checked})
    }
}

export function toggle_info(checked) {
    if (!checked) {
        localStorage.setItem('brand_not_found', 1);
    } else {
        localStorage.setItem('brand_not_found', 0);
    }
    return async dispatch => {
        dispatch({type: TOGGLE_INFO, payload: checked})
    }
}

export function form_brands_name_change(value) {
    let error = false;
    if (value !== '' && value.length < 3) {
        error = true;
    }
    return async dispatch => {
        dispatch({type: FORM_BRANDS_NAME, payload: {value: value, error: error}})
    }
}

export function form_email_change(value) {
    let error = false;

    const validate = (email) => {
        const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(String(email).toLowerCase());
    }
    if (value !== '' && value.length < 3) {
        error = true;
    }
    if (value !== '' && !validate(value)) {
        error = true;
    }
    return async dispatch => {
        dispatch({type: FORM_EMAIL, payload: {value: value, error: error}})
    }
}

export function form_policy_change(checked) {

    return async dispatch => {
        dispatch({type: FORM_POLICY, payload: {value: !checked, error: checked}})
    }
}

export function form_subscribe_change(checked) {
    return async dispatch => {
        dispatch({type: FORM_SUBSCRIBE, payload: !checked})
    }
}

export function airtable_config_get_label(config, key, lang) {
    for (let i = 0; i < config.length; i++) {
        if (config[i].fields.id && config[i].fields.locale && config[i].fields.label) {
            if (config[i].fields.id === key && config[i].fields.locale === lang) {
                return config[i].fields.label;
            }
        }
    }
    return null;
}

export function send_show_empty(search) {
    let brand_not_found = localStorage.getItem('brand_not_found');
    if (brand_not_found === 1) {
        let user_marker = get_user_marker_please();
        let attr_parameters = {
            utm_source: null,
            utm_medium: null,
            utm_campaign: null,
            utm_term: null,
            utm_content: null,
            promotion_code_id: null,
            referral_marker: null,
            ad_source: null,
            ad_content: null,
            tp_referrer: null,
        }
        attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
        attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
        attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
        attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
        attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
        attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
        attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
        attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
        attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
        attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);
        window.mamka('trackStructEvent', 'brand_store', 'brand_not_found', null, null, null, {
            marker: user_marker,
            attr_parameters: attr_parameters,
            input: search
        });
        localStorage.setItem('brand_not_found', 2);
    }
}

function pleaseGetCookie(name, def) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : def;
}

function send_marketing_event(data) {
    let request_url = 'https://www.travelpayouts.com/brands-directory/api/api.php?key=11eb6dd2f9dcf57rthtr853f9c';
    let email = data !== undefined && data.email !== undefined ? data.email : null;
    let page_url = window.location.href;
    let page_referrer = document.referrer;
    let ip = 0;
    let user_agent = 0;
    let user_marker = get_user_marker_please();
    let event_data = {
        "event": "email_input",
        "page_url": page_url,
        "page_referrer": page_referrer,
        "ip": ip,
        "user_agent": user_agent,
        "event_context": {
            "attr_parameters": {
                "utm_source": pleaseGetCookie('utm_source', null),
                "utm_medium": pleaseGetCookie('utm_medium', null),
                "utm_campaign": pleaseGetCookie('utm_campaign', null),
                "utm_term": pleaseGetCookie('utm_term', null),
                "utm_content": pleaseGetCookie('utm_content', null),
                "promotion_code_id": pleaseGetCookie('promotion_code_id', null),
                "referral_marker": pleaseGetCookie('referral_marker', null),
                "ad_source": pleaseGetCookie('ad_source', null),
                "ad_content": pleaseGetCookie('ad_content', null),
                "tp_referrer": pleaseGetCookie('tp_referrer', null),
            },
            "marker": user_marker,
            "email": email
        }
    }
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(event_data)
    };
    fetch(request_url, requestOptions)
        .then(response => response.json())
        .then(data => console.log(data));
}

export function send_form(e, brands_name, email, policy, subscribe) {
    e.preventDefault();
    return async dispatch => {
        try {
            let user_marker = get_user_marker_please();
            let attr_parameters = {
                utm_source: null,
                utm_medium: null,
                utm_campaign: null,
                utm_term: null,
                utm_content: null,
                promotion_code_id: null,
                referral_marker: null,
                ad_source: null,
                ad_content: null,
                tp_referrer: null,
            }
            attr_parameters.utm_source = mamkaGetCookie('utm_source', null);
            attr_parameters.utm_medium = mamkaGetCookie('utm_medium', null);
            attr_parameters.utm_campaign = mamkaGetCookie('utm_campaign', null);
            attr_parameters.utm_term = mamkaGetCookie('utm_term', null);
            attr_parameters.utm_content = mamkaGetCookie('utm_content', null);
            attr_parameters.promotion_code_id = mamkaGetCookie('promotion_code_id', null);
            attr_parameters.referral_marker = mamkaGetCookie('referral_marker', null);
            attr_parameters.ad_source = mamkaGetCookie('ad_source', null);
            attr_parameters.ad_content = mamkaGetCookie('ad_content', null);
            attr_parameters.tp_referrer = mamkaGetCookie('tp_referrer', null);

            window.mamka('trackStructEvent', 'brand_store', 'email_input', null, null, null, {
                marker: user_marker,
                attr_parameters: attr_parameters,
                email: email,
                input: brands_name
            });

            window.mindbox("async", {
                operation: "Lid.RegistrationOnLanding",
                data: {
                    customer: {
                        email: email,
                        area: {
                            ids: {
                                externalId: "en"
                            }
                        },
                        subscriptions: [
                            {
                                brand: "Travelpayouts",
                                pointOfContact: "Email",
                                isSubscribed: (subscribe ? "true" : "false")
                            }
                        ],
                        customFields: {
                            brandOfInterest: [brands_name]
                        },
                    },
                    pointOfContact: 'brands-directory',
                    addProductToList: {
                        product: {
                            ids: {
                                landings: 'brands-directory'
                            }
                        }
                    }
                },
            })

            window.dataLayer.push({
                'event': 'GAEvent',
                'eventId': 'd-v4-6',
                'eventCategory': 'Brands Directory',
                'eventAction': 'click',
                'eventLabel': 'brandsDirectory_searchClick_newBrand | ' + brands_name,
                'nonInteraction': false
            });

            window.dataLayer.push({
                'event': 'GA4Event',
                'eventId': 'd-v4-6',
                'eventName': 'brandsDirectory_searchClick_newBrand',
                'brand': brands_name
            });

            send_marketing_event({email: email, brands_name: brands_name});

            dispatch({type: FORM_SUBMIT, payload: true})
        } catch (e) {
            return false;
        }
    }

}